export { default } from './PermissionTable';
